import React from 'react';
import { Col, Container, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { useParams, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
import POTopBar from './POTopBar';
import * as componentAction from '../../store/component.action';
import { usePOrderDetailState } from './PODetailProvider';
import { SystemMasterSelect } from '../../../../Components/helper';
import RenderAllSection from './renderAllSection';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';

function PurchaseOrderDetail() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { t } = useTranslation('common');
  const location = useLocation();
  const searchParams = new URLSearchParams(location?.search);
  const isDuplicate = searchParams.get('forDuplication');
  const { poDetailstate, setPoDetailState, savePurchaseOrderData, redirectToListingPage, supplierType, pId } = usePOrderDetailState();
  const {
    confirmModalType,
    confirmModalState,
    confirmModalMessage,
    confirmModalSecondMessage,
    confirmModalThirdMessage,
    confirmModalShowthirdMsg,
    confirmModalTitle,
    confirmModalCommentState,
    confirmModalCommentMsg,
    confirmModalLoading,
    statusLog,
    showMarkDelievered,
    selectedDeliveryDate,
    showDateError,
    setDeliveredDate,
  } = poDetailstate;
  const previousStatusIndex = statusLog?.length ? statusLog.length - 1 : '';
  const previousStatus = statusLog?.[previousStatusIndex];

  const handleChangeTemplate = () => {
    setPoDetailState((prev) => ({
      ...prev,
      dropModal: true,
    }));
  };

  const handleSelectChange = async (value) => {
    setPoDetailState((prev) => ({
      ...prev,
      selectedTemplate: value,
    }));

    setPoDetailState((prev) => ({
      ...prev,
      templateJsonSchema: [],
    }));
    await dispatch(componentAction.fetchEditTemplate(value._id));
  };

  const cancelPurchaseOrder = async () => {
    await dispatch(componentAction.cancelPurchaseOrder(id, t));
    redirectToListingPage();
  };

  const handleConfirmModal = (type) => {
    let message = '';
    let secondMessage = '';
    let thirdMessage = '';
    let title = '';
    let showThirdMsg = false;
    let isCommentOn = false;
    switch (type) {
      case 'cancel':
        message = t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.CONFIRM_CANCEL');
        title = t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.CONFIRM_CANCEL_TITLE');
        showThirdMsg = true;
        break;
      case 'back':
        message = t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.CONFIRM_BACK');
        secondMessage = t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.CONFIRM_BACK_SECOND');
        thirdMessage = t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.CONFIRM_BACK_THIRD');
        title = t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.CONFIRM_BACK_TITLE');
        showThirdMsg = true;
        break;

      case 'Rejected':
      case 'Approved':
        message = `Are you sure you want to ${type === 'Reject' ? 'reject' : 'approve'} the purchase order?`;
        secondMessage = t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.CONFIRM_STATUS_SECOND');
        title = `${type === 'Reject' ? 'Reject' : 'Approve'} ${t(
          'PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.CONFIRM_STATUS_TITLE',
        )}`;
        isCommentOn = true;
        break;
      default:
        break;
    }
    setPoDetailState((poStateEnd) => ({
      ...poStateEnd,
      confirmModalType: type,
      confirmModalState: true,
      confirmModalMessage: message,
      confirmModalSecondMessage: secondMessage,
      confirmModalThirdMessage: thirdMessage,
      confirmModalShowthirdMsg: showThirdMsg,
      confirmModalTitle: title,
      confirmModalCommentState: isCommentOn,
    }));
  };

  const handleToggle = () => {
    setPoDetailState((poStateEnd) => ({
      ...poStateEnd,
      confirmModalType: '',
      confirmModalState: false,
      confirmModalMessage: '',
      confirmModalSecondMessage: '',
      confirmModalThirdMessage: '',
      confirmModalShowthirdMsg: false,
      confirmModalTitle: '',
      confirmModalCommentState: false,
      confirmModalCommentMsg: '',
      confirmModalLoading: false,
      showDateError: false,
      selectedDeliveryDate: '',
    }));
  };

  const onConfirm = async () => {
    if (confirmModalType === 'back') {
      redirectToListingPage();
    } else if (confirmModalType === 'cancel') {
      cancelPurchaseOrder();
    } else {
      const data = {
        comment: confirmModalCommentMsg,
        purchaseOrderId: pId || id,
        status: confirmModalType,
      };
      const response = await dispatch(componentAction.rejectApprove(data, t));
      if (response) {
        handleToggle();
        redirectToListingPage();
      }
    }
  };

  const onChange = (check) => {
    setPoDetailState((poState) => ({
      ...poState,
      showMarkDelievered: check.target.checked,
    }));
  };

  const toggleMarkComplete = () => {
    setPoDetailState((poState) => ({
      ...poState,
      showMarkDelievered: !showMarkDelievered,
    }));
  };
  const handleSelectedDate = (e) => {
    setPoDetailState((poState) => ({
      ...poState,
      selectedDeliveryDate: e,
    }));
  };

  const onConfirmComplete = async () => {
    if (selectedDeliveryDate) {
      const data = {
        deliveryDate: selectedDeliveryDate,
        purchaseOrderId: pId || id,
        status: 'Delivered',
      };
      const response = await dispatch(componentAction.rejectApprove(data, t));
      if (response) {
        handleToggle();
        redirectToListingPage();
      }
    } else {
      setPoDetailState((poState) => ({
        ...poState,
        showDateError: true,
      }));
    }
  };
  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.CREATE_PO_TITLE')}</h4>
        </div>
        <div className="search-filter">
          {poDetailstate?.dropModal && (
            <button
              type="button"
              title={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.ADD_TO_CUSTOM_MODULE')}
              className="filter-btn filter-button_delete"
            >
              <OverlayTrigger
                placement={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.TEMPLATE')}
                trigger="click"
                rootClose
                overlay={
                  <Popover className="custom-popover">
                    <Popover.Content>
                      <div className="d-flex">
                        <div className="flex-fill">
                          <Select
                            name="Template"
                            type="text"
                            styles={SystemMasterSelect}
                            placeholder={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.SELECT_TEMPLATE')}
                            options={poDetailstate?.activetemplate}
                            getOptionLabel={({ name }) => `${name}`}
                            getOptionValue={({ name }) => `${name}`}
                            value={poDetailstate?.selectedTemplate || null}
                            onChange={(selected) => handleSelectChange(selected)}
                          />
                        </div>
                      </div>
                    </Popover.Content>
                  </Popover>
                }
              >
                <i className="icon-add_to_colour_group" />
              </OverlayTrigger>
            </button>
          )}
          {setDeliveredDate && !isDuplicate && previousStatus?.status === 'Delivered' ? (
            <strong>
              {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.DELIVERY_DATE')}:{' '}
              {moment(setDeliveredDate).format('DD-MMM-YYYY')}
            </strong>
          ) : null}
          {!supplierType && !pId && ['Draft', 'Rejected'].includes(previousStatus?.status) && (
            <button
              className="show-button ml-1"
              type="button"
              name="ChangeTemp"
              onClick={() => {
                handleChangeTemplate();
              }}
            >
              {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.CHANGE_TEMPLATE')}{' '}
            </button>
          )}
          {!supplierType && !pId && isDuplicate && ['Delivered'].includes(previousStatus?.status) && (
            <button
              className="show-button ml-1"
              type="button"
              name="ChangeTemp"
              onClick={() => {
                handleChangeTemplate();
              }}
            >
              {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.CHANGE_TEMPLATE')}{' '}
            </button>
          )}
          {['Sent', 'Approved', 'Active'].includes(previousStatus?.status) && !isDuplicate && !supplierType && (
            <div className="checkbox-label ">
              <input type="checkbox" id="MarkAsDelivered" name="MarkAsDelivery" checked={showMarkDelievered} onChange={(e) => onChange(e)} />
              <label htmlFor="MarkAsDelivered" className="chklabel">
                <span>{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.MARK_AS_DELIVERED')}</span>
              </label>
            </div>
          )}
          {!supplierType && !isDuplicate && !pId && ['Sent', 'Rejected', 'Active'].includes(previousStatus?.status) && (
            <button className="show-button ml-1" type="button" name="Cancel" title="Cancel" onClick={() => handleConfirmModal('cancel')}>
              {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.CANCEL_PO')}
            </button>
          )}
          {!isDuplicate && ['Sent', 'Active'].includes(previousStatus?.status) && !pId && (
            <>
              <button className="btn btn-po btn-red m-0 ml-1" type="button" onClick={() => handleConfirmModal('Rejected')}>
                {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.REJECT_PO')}
              </button>
              <button className="btn btn-po btn-green m-0 ml-1" type="button" onClick={() => handleConfirmModal('Approved')}>
                {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.APPROVE_PO')}
              </button>
            </>
          )}
          {pId && supplierType && previousStatus?.status === 'Sent' && (
            <>
              <button className="btn btn-po btn-red m-0 ml-1" type="button" onClick={() => handleConfirmModal('Rejected')}>
                {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.REJECT_PO')}
              </button>
              <button className="btn btn-po btn-green m-0 ml-1" type="button" onClick={() => handleConfirmModal('Approved')}>
                {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.APPROVE_PO')}
              </button>
            </>
          )}
          {!supplierType && !pId && isDuplicate && ['Approved', 'Delivered', 'Canceled', 'Cancelled'].includes(previousStatus?.status) && (
            <button
              type="button"
              className="filter-btn filter-button_add"
              name="Save"
              title={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.SAVE')}
              onClick={savePurchaseOrderData}
            >
              <i className="icon-Save " />
            </button>
          )}
          {!supplierType && !pId && !['Approved', 'Delivered', 'Canceled', 'Cancelled'].includes(previousStatus?.status) && (
            <button
              type="button"
              className="filter-btn filter-button_add"
              name="Save"
              title={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.SAVE')}
              onClick={savePurchaseOrderData}
            >
              <i className="icon-Save " />
            </button>
          )}
          {!pId && !['Canceled', 'Cancelled'].includes(previousStatus?.status) && (
            <button className="show-button ml-1" type="button" onClick={() => handleConfirmModal('back')}>
              {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.BACK')}
            </button>
          )}
          {!pId && ['Canceled', 'Cancelled'].includes(previousStatus?.status) && (
            <button className="show-button ml-1" type="button" onClick={redirectToListingPage}>
              {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.BACK')}
            </button>
          )}
        </div>
      </div>

      <Container>
        <Row>
          <Col lg={12}>
            <POTopBar supplierType={!!supplierType} />
          </Col>
          <Col lg={12}>
            <RenderAllSection supplierType={!!supplierType} />
          </Col>
        </Row>
      </Container>
      {confirmModalState && (
        <ConfirmationPopup
          onOpen={confirmModalState}
          onConfirm={onConfirm}
          loading={confirmModalLoading}
          title={confirmModalTitle}
          message={confirmModalMessage}
          toggle={handleToggle}
          secondMessage={confirmModalSecondMessage}
          showThirdMsg={confirmModalShowthirdMsg}
          thirdMessage={confirmModalThirdMessage}
          commentText={(e) =>
            setPoDetailState((prevState) => ({
              ...prevState,
              confirmModalCommentMsg: e.target.value,
            }))
          }
          isCommentOn={confirmModalCommentState}
        />
      )}
      {showMarkDelievered && (
        <ConfirmationPopup
          onOpen={showMarkDelievered}
          onConfirm={onConfirmComplete}
          title={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.DELIVERY_DATE_TITLE')}
          message={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DETAIL.DELIVERY_DATE_MESSAGE')}
          showDate
          showDateError={showDateError}
          setSelectedDate={(e) => handleSelectedDate(e)}
          selectedDate={selectedDeliveryDate}
          toggle={toggleMarkComplete}
        />
      )}
    </>
  );
}

export default PurchaseOrderDetail;
